import { ValueOfKey } from '../../utils-types';

export const PAYMENT_TYPES = {
  NEW: 'NEW',
  OLD: 'OLD',
  ALL: 'ALL',
} as const;

export type PaymentType = ValueOfKey<typeof PAYMENT_TYPES>;
